import { useTable, useSortBy, usePagination } from 'react-table';

/*
The useTable instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useTable.md#instance-properties
The useSortBy instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useSortBy.md#instance-properties
The usePagination instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/usePagination.md#instance-properties
*/
const usePaginationTable = ({
  columns,
  data,
  defaultPageSize,
  defaultSortId,
  defaultSortDesc = false,
}) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: defaultPageSize || 10,
        sortBy: [{ id: defaultSortId, desc: defaultSortDesc }],
      },
    },
    useSortBy,
    usePagination,
  );
  return { columnsLength: columns.length, ...tableInstance };
};

export default usePaginationTable;
